import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import { Picture } from '@ucheba/ui/components/Picture'

const Logo = styled(Picture)`
  width: 56px;
  margin-right: ${sv.spacing.xlarge};
  flex-shrink: 0;

  img {
    max-width: 56px;
    max-height: 56px;
  }
`

const Institution = styled.a`
  display: flex;
  align-items: center;
  ${sm.linkColor.black};
`

const Block = styled.div``

export default { Block, Logo, Institution }
